module.exports = __webpack_public_path__ + "media/snacks/eats-some-snacks-a9c161da.svg";